export const tokenKey = 'token'
export const roleKey = 'role'
